export default "__VITE_ASSET__D0TNJVOp__"